import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import SaintPierreEtMiquelonReport from '../../components/SaintPierreEtMiquelonReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/SaintPierreEtMiquelonSummarySelectors';

export function SaintPierreEtMiquelonSummaryContainer(props) {
  return (
    <SaintPierreEtMiquelonReport
      reportId={ReportDefinitions.SAINT_PIERRE_ET_MIQUELON_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

SaintPierreEtMiquelonSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(SaintPierreEtMiquelonSummaryContainer);
